<template>
    <AllocationSelectionFilter
        v-if="sections"
        ref="allocation-selection-filter"
        :status="status"
        :label="label"
        :allocation-count="allocationCount"
        :plus-count="plusCount"
        :minus-count="minusCount"
        :type="type"
        @click="undoChanges"
    >
        <template #icon>
            <BallotIcon v-if="type === 'Event'" class="size-5" />
            <ConstructionIcon v-if="type === 'Project'" class="size-5" />
            <AirplaneIcon v-if="type === 'ExternalEvent'" class="size-5" />
        </template>

        <template #panel>
            <div class="space-y-2 flex flex-col">
                <AllocationDesignerSelectionPanel
                    :sections="sections"
                    :type="type"
                    @close="onPanelClose"
                    @toggle-expanded="toggleSectionIsExpanded"
                    @toggle-visibility="toggleVisibility"
                    @toggle-override-visibility="toggleOverrideVisibility"
                    @make-main-variant-visible="makeMainVariantVisible"
                    @make-active-variants-visible="makeActiveVariantsVisible"
                    @toggle-non-active-variants="toggleNonActiveVariants"
                />
            </div>
        </template>
    </AllocationSelectionFilter>
</template>
<script setup lang="ts">
import AllocationSelectionFilter, {
    AllocationSelectionFilterStatus,
} from '@/components/AllocationSelectionFilter/AllocationSelectionFilter.vue';
import { AllocationGroupType } from '@/components/AllocationSelectionPanel/AllocationSelectionPanel.types';
import { AllocationVariantOverrideVisibility } from '@/components/AllocationSelectionPanel/AllocationVariantVisibilityOverride.vue';
import AirplaneIcon from '@/components/Icon/AirplaneIcon.vue';
import BallotIcon from '@/components/Icon/BallotIcon.vue';
import ConstructionIcon from '@/components/Icon/ConstructionIcon.vue';
import { computed, useTemplateRef } from 'vue';
import AllocationDesignerSelectionPanel, { Section } from './AllocationDesignerSelectionPanel.vue';
import { VariantStateVisibility } from './AllocationSelectionFilter.state.ts';

const props = defineProps<{
    type: AllocationGroupType;
    sections: Section[];
    label: string;
    status: AllocationSelectionFilterStatus;
    allocationCount: number;
    plusCount: number;
    minusCount: number;
    undoChanges: () => void;
    toggleSectionIsExpanded: (sectionId: string) => void;
    toggleVisibility: (toggleValue: VariantStateVisibility, sectionId: string, variantId: string) => void;
    toggleOverrideVisibility?: (
        toggleValue: AllocationVariantOverrideVisibility,
        sectionId: string,
        variantId: string,
    ) => void;
    makeMainVariantVisible: () => void;
    makeActiveVariantsVisible: () => void;
    toggleNonActiveVariants: (sectionId: string) => void;
}>();

const type = computed(() => props.type);

const allocationSelectionPanelRef = useTemplateRef('allocation-selection-filter');

function onPanelClose() {
    allocationSelectionPanelRef.value?.hide();
}
</script>
